import { GENDER_FEMALE } from '../common/GenderOptions';
import moment from 'moment';
import MessageFormat from 'messageformat';

const retirementTable = {
	'1935': ['60', '57', '56', '55', '54', '53'],
	'1936': ['60;2', '57', '56', '55', '54', '53'],
	'1937': ['60;4', '57', '56', '55', '54', '53'],
	'1938': ['60;6', '57', '56', '55', '54', '53'],
	'1939': ['60;8', '57;4', '56', '55', '54', '53'],
	'1940': ['60;10', '57;8', '56;4', '55', '54', '53'],
	'1941': ['61', '58', '56;8', '55;4', '54', '53'],
	'1942': ['61;2', '58;4', '57', '55;8', '54;4', '53'],
	'1943': ['61;4', '58;8', '57;4', '56', '54;8', '53;4'],
	'1944': ['61;6', '59', '57;8', '56;4', '55', '53;8'],
	'1945': ['61;8', '59;4', '58', '56;8', '55;4', '54'],
	'1946': ['61;10', '59;8', '58;4', '57', '55;8', '54;4'],
	'1947': ['62', '60', '58;8', '57;4', '56', '54;8'],
	'1948': ['62;2', '60;4', '59', '57;8', '56;4', '55'],
	'1949': ['62;4', '60;8', '59;4', '58', '56;8', '55;4'],
	'1950': ['62;6', '61', '59;8', '58;4', '57', '55;8'],
	'1951': ['62;8', '61;4', '60', '	58;8', '57;4', '56'],
	'1952': ['62;10', '61;8', '60;4', '59', '57;8', '56;4'],
	'1953': ['63', '62', '60;8', '59;4', '58', '56;8'],
	'1954': ['63;2', '62;4', '61;0', '59;8', '58;4', '57;0'],
	'1955': ['63;4', '62;8', '61;4', '60;0', '58;8', '57;4'],
	'1956': ['63;6', '63;2', '61;8', '60;4', '59;0', '57;8'],
	'1957': ['63;8', '63;8', '62;2', '60;8', '59;4', '58;0'],
	'1958': ['63;10', '63;10', '62;8', '61;2', '59;8', '58;4'],
	'1959': ['64;0', '64;0', '63;2', '61;8', '60;2', '58;8'],
	'1960': ['64;2', '64;2', '63;8', '62;2', '60;8', '59;2'],
	'1961': ['64;4', '64;4', '64;2', '62;8', '61;2', '59;8'],
	'1962': ['64;6', '64;6', '64;6', '63;2', '61;8', '60;2'],
	'1963': ['64;8', '64;8', '64;8', '63;8', '62;2', '60;8'],
	'1964': ['64;10', '64;10', '64;10', '64;2', '62;8', '61;2'],
	'1965': ['65;0', '65;0', '65;0', '64;8', '63;2', '61;8'],
	'1966': ['65;0', '65;0', '65;0', '65;0', '63;8', '62;2'],
	'1967': ['65;0', '65;0', '65;0', '65;0', '64;2', '62;8'],
	'1968': ['65;0', '65;0', '65;0', '65;0', '64;8', '63;2'],
	'1969': ['65;0', '65;0', '65;0', '65;0', '65;0', '63;8'],
	'1970': ['65;0', '65;0', '65;0', '65;0', '65;0', '64;2'],
	'1971': ['65;0', '65;0', '65;0', '65;0', '65;0', '64;8'],
	'1972': ['65;0', '65;0', '65;0', '65;0', '65;0', '65;0'],
};

export function getRetirementDate({ dateOfBorn, gender, children }) {
	let retirementYear = 65;
	let retirementMonth = 0;

	let yearOfBorn = dateOfBorn.year();

	if (yearOfBorn < 1972) {
		if (yearOfBorn < 1935) {
			yearOfBorn = 1935;
		}

		let arrayIndex = 0;
		if (gender === GENDER_FEMALE) {
			arrayIndex = 1 + parseInt(children, 10);
		}

		const retirementData = retirementTable[yearOfBorn][arrayIndex].split(';');
		retirementYear = parseInt(retirementData[0], 10);
		retirementMonth = retirementData[1] ? parseInt(retirementData[1], 10) : 0;
	}

	return {
		year: retirementYear,
		month: retirementMonth,
	};
}

export function formatOutput(year, month) {
	const mf = new MessageFormat('cs');
	const remainTemplate = mf.compile(`{YEAR, plural,
		=0 {# roků}
		=1 {# rok}
		=2 {# roky}
		=3 {# roky}
		=4 {# roky}
		other {# roků}
	} a {MONTH, plural,
		=0 {# měsíců}
		=1 {# měsíc}
		=2 {# měsíce}
		=3 {# měsíce}
		=4 {# měsíce}
		other {# měsíců}
	}`);

	return remainTemplate({
		YEAR: year,
		MONTH: month,
	});
}

export function getRetirementRemain(retirementDate) {
	const currentDate = moment();
	if (retirementDate.diff(currentDate, 'month') <= 0) {
		return formatOutput(0, 0);
	}

	const remainDate = retirementDate
		.clone()
		.subtract(currentDate.year(), 'years')
		.subtract(currentDate.month(), 'months');
	return formatOutput(parseInt(remainDate.format('YY'), 10), parseInt(remainDate.format('MM'), 10));
}

export function getRetirement(dateOfBorn, gender, children) {
	const retirementData = getRetirementDate({ dateOfBorn, gender, children });
	const retirementDate = dateOfBorn
		.clone()
		.add(retirementData.year, 'y')
		.add(retirementData.month, 'M');

	return {
		retirementAge: `${retirementData.year} roků`,
		retirementDate: retirementDate.format('DD.MM.YYYY'),
		retirementRemains: getRetirementRemain(retirementDate),
	};
}

export default function({ dateOfBorn, gender, children }) {
	return getRetirement(moment(dateOfBorn, 'DD.MM.YYYY'), gender, children);
}
